import React from "react";
import "./Basket_crane_rental.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Crane_Rental1() {
  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}

      <div className="Basket_crane_rental-hero">

        <div className="Basket_crane_rental-overlay">
          <h1>השכרת מנוף זרוע</h1>
        </div>

      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              השכרת מנוף זרוע
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/25.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי השכרת מנוף הזרוע של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            השכרת מנוף זרוע מאפשרת לבצע עבודות הרמה, שינוע והעמסה
            במגוון תנאים ובאתרים שבהם נדרשת הגעה של המנוף לנקודות
            עבודה שונות. נצר הובלות ומנופים מספקת שירותי השכרת
            מנוף זרוע לקבלנים, חברות, עסקים, אנשי מקצוע ולקוחות
            פרטיים, בהתאם לסוג העבודה, למשקל המטען ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/25.jpeg"
                alt="השכרת מנוף זרוע"
              />
            </div>

            <div className="text-box">

              <p>
                השכרת מנוף זרוע דורשת התאמה בין סוג העבודה, משקל
                המטען, טווח ההרמה, תנאי השטח ומיקום המשאית. לפני
                ביצוע העבודה חשוב לבחון את משקל המטען, גובה ההרמה,
                מרחק ההרמה, אזור העבודה והאפשרות להציב את המשאית
                והמנוף במקום המתאים.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות הרמה ושינוע
                באמצעות מנוף זרוע, לרבות העמסת ציוד, פריקת מטענים,
                הרמת חומרי בניין, שינוע ציוד כבד ועבודות נוספות,
                בהתאם לסוג המשימה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            השכרת מנוף זרוע – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודה עם מנוף זרוע מתחילה בבדיקת פרטי העבודה.
              יש להבין מהו משקל המטען, מהן מידותיו, מהו גובה ההרמה,
              מהו מרחק ההרמה ומהם תנאי השטח במקום.
            </p>

            <p>
              בנוסף יש לבחון את נקודת ההצבה של המשאית והמנוף,
              את תנאי הגישה ואת המרחב הנדרש כדי לבצע את העבודה
              בצורה מסודרת ובהתאם לתנאים בשטח.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              מנוף זרוע להרמת ציוד כבד
            </h2>

            <p>
              מנוף זרוע מתאים לעבודות שבהן יש צורך להרים ולשנע
              ציוד ומטענים במשקלים שונים. בהתאם לסוג המנוף ולנתוני
              העבודה ניתן לבצע הרמה והצבה בנקודות שונות באתר.
            </p>

            <p>
              ניתן להשתמש במנוף זרוע לצורך הרמת מכונות, ציוד
              תעשייתי, חומרי בניין, משטחים, מתקנים ומטענים נוספים,
              בהתאם לדרישות הפרויקט ולתנאי העבודה.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              השכרת מנוף זרוע לאתרי בנייה ולעסקים
            </h2>

            <p>
              באתרי בנייה, מפעלים, עסקים ומחסנים יש לעיתים צורך
              בהעמסה, פריקה והרמה של ציוד ומטענים כבדים. מנוף זרוע
              יכול לסייע בביצוע משימות אלו בהתאם לאפשרויות העבודה
              ולתנאי השטח.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי השכרת מנוף זרוע
              לאתרי בנייה, עסקים, מפעלים ולמגוון נקודות ברחבי
              הארץ, בהתאם לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              מנוף זרוע להעמסה ופריקה
            </h2>

            <p>
              מנוף זרוע יכול לשמש להעמסה ולפריקה של מטענים במקרים
              שבהם יש צורך בהרמה והעברה של ציוד מהמשאית אל נקודת
              יעד סמוכה או להפך.
            </p>

            <p>
              השימוש במנוף מאפשר לבצע את העבודה בהתאם לתנאי האתר,
              למיקום המטען ולנקודת הפריקה או ההצבה הנדרשת.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              מנוף זרוע להרמת חומרי בניין וציוד
            </h2>

            <p>
              מנוף זרוע מתאים למגוון עבודות הרמה ושינוע של חומרי
              בניין וציוד, כגון משטחים, קורות, לוחות, מכונות,
              מתקנים וציוד לאתרי בנייה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההרמה כך שתתאים
              למשקל המטען, למידותיו, לטווח ההרמה ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להשכרת מנוף זרוע?
            </h2>

            <p>
              עבודות הרמה ושינוע באמצעות מנוף זרוע דורשות תכנון
              מוקדם, התאמת ציוד מתאים ובדיקה של תנאי השטח. תכנון
              נכון יכול לסייע בביצוע העבודה בצורה מסודרת ויעילה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון מנוף הזרוע לסוג
              העבודה, למשקל המטען, לטווח ההרמה, לתנאי הגישה
              ולדרישות הלקוח.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – השכרת מנוף זרוע בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי השכרת מנוף
              זרוע להרמה, העמסה, פריקה ושינוע של ציוד ומטענים
              לקבלנים, חברות, עסקים, אנשי מקצוע ולקוחות פרטיים.
              השירות ניתן בהתאם לסוג העבודה, למשקל המטען ולתנאים
              הקיימים בשטח.
            </p>

            <p>
              צריכים מנוף זרוע? צרו איתנו קשר, ספרו לנו מה
              משקל המטען, מה גובה ההרמה, מה המרחק והיכן מתבצעת
              העבודה, ונבחן עבורכם את פתרון ההרמה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Basket_crane_rental"
              className="link-right"
            >
השכרת מנוף סל            </Link>

            <Link
              to="/Hourly_Lifting_Basket_Rental"
              className="link-left"
            >
השכרת סל הרמה לפי שעה            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
